import * as ExpenseCalcs from 'app/calcs/expenses'
import { AccountsActions, CreateResponse } from 'app/redux/Accounts/actions'
import { ActionCreator } from 'app/redux/ActionCreator'
import * as AppReducerModule from 'app/redux/App/reducer'
import { ProfileActions } from 'app/redux/Profile/actions'
import { Profile } from 'app/redux/Profile/model'
import { UserActions } from 'app/redux/User/actions'
import { MiscService } from 'app/services/MiscService'
import { theCensusInfo } from 'app/services/models/PublicCensusInfo'
import { getBrandHelpers, getWebServicesConfig, loadCustomerConfig } from 'config'
import * as moment from 'moment'

class AppActionCreator extends ActionCreator<AppReducerModule.IAppState> {

  init() {
    return UserActions.init()
    .then(() => this.postProcess())
  }

  login(username: string, password: string) {
    return UserActions.login(username, password)
    .then(() => this.postProcess())
  }

  /**
   * Register a new user. If the account is created, create an initial profile
   *
   * @param username
   * @param password
   * @param args
   */
  register(username: string, password: string, args: any): Promise<Profile> {
    return AccountsActions.create(username, password, args)
      .then((cr: CreateResponse) => {
        // tslint:disable-next-line:no-console
        console.log('OK, the account was created. cr: ' + JSON.stringify(cr))
        const profile = new Profile()
        profile.showIntroduction = true
        profile.extraInfo = cr.ExtraInfo
        theCensusInfo.fromWire(cr.censusInfo)
        return getBrandHelpers().loadProfilePresets(profile)
        .then(() => {
          return ProfileActions.store(profile, true)
            .then((p) => {
              // tslint:disable-next-line:no-console
              console.log('OK, the profile was created. p: ' + JSON.stringify(p, undefined, 4))
              UserActions.loginWithToken(username, cr.AccessToken, cr)
              return p
            })
        })
      })
  }

  private postProcess() {
    const accessToken = this.getSharedVar('accessToken')
    if (!accessToken) { return Promise.resolve(undefined) }
    const endpoint = getWebServicesConfig().miscEndpoint
    const svc = new MiscService(endpoint)
    return svc.getExtraInfo(accessToken)
    .then((resp) => {
      return loadCustomerConfig(resp.customerName)
      .catch(() => { /* ignore errors - likely from legacy sites that do NOT use .json config files */})
      .then(() => {
        theCensusInfo.fromWire(resp.censusInfo)
        return ProfileActions.retrieve(resp.success ? resp.extraInfo : undefined)
      })
    })
  }
}

const AppActions = new AppActionCreator()

export default AppActions
export {
  AppActions,
  AppActionCreator
}



// WEBPACK FOOTER //
// ./src/app/redux/App/actions/index.ts